import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  useNavigate,
} from "react-router-dom";
import Product from "./Product";
import { productDataList } from "../data/productListData";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { buttonStyle } from "../styles/buttonStyles";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import NightlightIcon from "@mui/icons-material/Nightlight";
import Login from "./Login";
import LoginPage from "./login/LoginPage";
import { AppBar, Toolbar, Typography, Button, Box, Menu } from "@mui/material";
import logo from "../assets/images/logo.png";
import AuthService from "../utils/AuthService";

const Appbar = ({
  isMobile,
  handleDrawerToggle,
  userInfo,
  handleLoginSuccess,
  themeMode,
  toggleTheme,
  onAboutClick,
  onInstClick,
  ontestimonialClick,
  onCompareProClick,
  onQARefClick,
  onContactRefClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null); // State to manage anchorEl (the button)
  const [isHovered, setIsHovered] = useState(false); // State to track hover status
  const navigate = useNavigate();

  const handleMouseEnter = (event) => {
    setIsHovered(true);
    setAnchorEl(event.currentTarget); // Set the anchor element to the Products button
  };

  // Handle mouse leave event from the Products button
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  // Handle closing of the dropdown menu when clicking outside
  const handleClose = () => {
    setIsHovered(false);
    setAnchorEl(null); // Close the menu when clicking away
  };
  const handleLogout = () => {
    AuthService.logOut();
    navigate("/"); // Redirects to homepage
  };
  return (
    <AppBar position="static" color="transparent" elevation={0}>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {isMobile && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}
        {!isMobile && (
          <>
            <Link to="/" style={{ textDecoration: "none" }}>
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: 70,
                  cursor: "pointer",
                }}
              />
            </Link>
            <Divider />
            <Box
              sx={{
                display: "flex",
                flexGrow: 1,
                gap: 2,
                justifyContent: "center",
              }}
            >
              <Button sx={{ fontSize: "1rem" }} onClick={onAboutClick}>
                About the Course
              </Button>
              {/* <Menu
                anchorEl={anchorEl} // Attach the menu to the Products button
                open={isHovered} // Open menu when hovered
                onClose={handleClose} // Close the menu when clicking away
                onMouseLeave={handleMouseLeave} // Close the menu if mouse leaves the menu
                PaperProps={{
                  sx: {
                    borderRadius: "8px",
                    maxWidth: 360, // Limit max width of menu
                    maxHeight: "auto", // Allow space for larger content
                    overflowY: "auto", // Enable scrolling when the content is too long
                    boxShadow: 3, // Add a shadow to make the menu stand out
                    cursor: "pointer",
                  },
                }}
              >
                
                {productDataList.map((product) => (
                  <Product product={product} handleClose={handleClose} />
                ))}
              </Menu> */}
              <Button component={Link} to="/enroll" sx={{ fontSize: "1rem" }}>
                Enroll
              </Button>
              <Button sx={{ fontSize: "1rem" }} onClick={onInstClick}>
                Instructor
              </Button>
              <Button sx={{ fontSize: "1rem" }} onClick={ontestimonialClick}>
                Testimonials
              </Button>
              <Button sx={{ fontSize: "1rem" }} onClick={onCompareProClick}>
                Compare Programs
              </Button>
              <Button sx={{ fontSize: "1rem" }} onClick={onQARefClick}>
                Q&A
              </Button>
              <Button sx={{ fontSize: "1rem" }} onClick={onContactRefClick}>
                Contact
              </Button>
            </Box>
          </>
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {AuthService.getUserInfo() ? (
            <Button variant="contained" onClick={handleLogout}>
              Logout
            </Button>
          ) : (
            <Link to="/loginPage" style={{ textDecoration: "none" }}>
              <Button variant="contained">Login</Button>
            </Link>
          )}

          {themeMode === "light" ? (
            <WbSunnyIcon
              sx={{ cursor: "pointer", ml: 1 }}
              onClick={toggleTheme}
            />
          ) : (
            <NightlightIcon
              sx={{ cursor: "pointer", ml: 1 }}
              onClick={toggleTheme}
            />
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Appbar;
